import './App.css';
import { BrowserView, MobileView } from 'react-device-detect';
import { isMobile } from 'react-device-detect';
import MobileApp from './Mobile/MobileApp';
import DesktopApp from './Desktop/DesktopApp';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ProtectedRoute} from "./Components/RequireAuth/RequireAuth";
import MobileLogin from "./Mobile/MobileLogin/MobileLogin";
import DesktopLogin from "./Desktop/DesktopLogin/DesktopLogin";
import {Fragment} from "react";
import DesktopRegister from "./Desktop/DesktopRegister/DesktopRegister";
import MobileRegister from "./Mobile/MobileRegister/MobileRegister";
import CourtRules from "./Pages/CourtRules/CourtRules";

function App() {

    if (isMobile) {
        return (
            <Fragment>
                <div className="App">
                    <BrowserRouter>
                        <Routes>
                            <Route path="/login" element={<MobileLogin />} />
                            <Route path="/register" element={ <MobileRegister /> } />
                            <Route path="/api/auth/yandex/login/" />
                            <Route path="/api/auth/vk/login/" />
                            <Route path="/court_rules" element={ <CourtRules /> } />
                            <Route path="/*" element={ <ProtectedRoute><MobileApp /></ProtectedRoute>} />
                        </Routes>
                    </BrowserRouter>
                    {/*<MobileApp />*/}
                </div>
                <div className={'orientation-warning-container'}>
                    <p className={'orientation-warning-text'}>Пожалуйста, поверните экран.</p>
                </div>
            </Fragment>
        );
    } else {
        return (
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<DesktopLogin />} />
                        <Route path="/register" element={ <DesktopRegister /> } />
                        <Route path="/api/auth/yandex/login/" />
                        <Route path="/api/auth/vk/login/" />
                        <Route path="/court_rules" element={ <CourtRules /> } />
                        <Route path="/*" element={ <ProtectedRoute><DesktopApp /></ProtectedRoute>} />
                    </Routes>
                </BrowserRouter>
                {/*<DesktopApp />*/}
            </div>
        );
    }
//   return (
//     <div className="App">
//
//         <BrowserView>
//           <DesktopApp />
//         </BrowserView>
//         <MobileView>
//             <MobileApp />
//         </MobileView>
//     </div>
//   );

}

export default App;
